/**
 * Canonical profile completion contract.
 *
 * A profile is "complete" when all mandatory identity fields are present.
 * This function is the SINGLE source of truth — no page may roll its own check.
 */

import type { Profile } from "@/hooks/useProfile";

/** Minimum fields required for a profile to be considered complete. */
export function isProfileComplete(profile: Profile | null | undefined): boolean {
  if (!profile) return false;
  // full_name is the mandatory identity field for onboarding completion.
  // phone_last4 is set by activation — its absence means activation didn't persist PII fully,
  // but we rely on activation status separately, so we only gate on full_name here.
  return !!profile.full_name && profile.full_name.trim().length > 0;
}

/** Check if user has completed the onboarding flow. */
export function hasCompletedOnboarding(profile: Profile | null | undefined): boolean {
  if (!profile) return false;
  return !!profile.onboarding_completed_at;
}
